// Teams SSO token source. When the admin app is hosted inside Microsoft Teams,
// we authenticate via Teams SSO (silent, no popup) instead of an MSAL redirect.
import { app, authentication } from "@microsoft/teams-js";

let inited = false;

async function ensureInit(): Promise<boolean> {
  if (inited) return true;
  try {
    await app.initialize();
    inited = true;
    return true;
  } catch {
    return false;
  }
}

/** Resolves true when running inside a Microsoft Teams host, false otherwise. */
export async function isInTeams(): Promise<boolean> {
  return ensureInit();
}

/**
 * Returns a Teams SSO bearer token for the current user.
 * Throws when the app is not running inside Teams.
 */
export async function getTeamsToken(): Promise<string> {
  if (!(await ensureInit())) throw new Error("not running in Teams");
  return authentication.getAuthToken();
}
